import { NodeType } from '@cadet-dsl';
import {
  ADAPTIVE_BLUE,
  ADAPTIVE_GREEN,
  ADAPTIVE_ORANGE,
  ADAPTIVE_PURPLE,
  ADAPTIVE_RED,
  ADAPTIVE_YELLOW
} from '@color';
import { IString } from '@strings';
import { immerable } from '@utils';
import { NodeSpec } from './NodeSpec';

/* ------------------------------------------------------------------ */
/*  Group colours (kept for renderer-parity)                          */
/* ------------------------------------------------------------------ */
export const GroupColors = new Set<string>([
  ADAPTIVE_RED,
  ADAPTIVE_ORANGE,
  ADAPTIVE_YELLOW,
  ADAPTIVE_GREEN,
  ADAPTIVE_BLUE,
  ADAPTIVE_PURPLE
]);

export const DEFAULT_GROUP_COLOR = ADAPTIVE_BLUE;

/* ------------------------------------------------------------------ */
/*  Runtime data wrapper                                              */
/* ------------------------------------------------------------------ */
export class GroupSpec extends NodeSpec {
  [immerable] = true;

  isCollapsed = false;
  color: string;

  constructor(title: IString, color: string = DEFAULT_GROUP_COLOR) {
    super('Group', NodeType.GROUP, { title });

    this.color = color;
  }
}
